import { FC } from 'react';

import { Typography } from '@mui/material';

import DashboardsList from '@src/main/ui/components/common/Dashboard/DashboardList/DashboardsList';
import DashboardsModal from '@src/main/ui/components/common/Dashboard/DashboardModal/DashboardModal';
import { useSearch } from '@src/main/ui/components/Search/hooks/useSearch';
import SearchBar from '@src/main/ui/components/Search/SearchBar';

const Search: FC = () => {
  const { searchInput, filteredDashboardsTopResults, filteredDashboardsOtherResults } = useSearch();

  const isNoDashboardsFound =
    filteredDashboardsTopResults &&
    filteredDashboardsOtherResults &&
    filteredDashboardsTopResults?.concat(filteredDashboardsOtherResults).length === 0;

  return (
    <>
      <SearchBar placeholder="Which dashboards are you looking for?" />
      {isNoDashboardsFound && (
        <Typography variant="h5" sx={{ marginTop: '30px', textAlign: 'center' }}>
          {searchInput && 'No dashboards found'}
        </Typography>
      )}
      <DashboardsList
        title="Top Results"
        isExpandable={false}
        dashboards={filteredDashboardsTopResults || []}
        highlighFields={['title', 'keyTags']}
        actions={{
          favorite: true,
          info: true,
        }}
      />
      <DashboardsList
        title="Other Results"
        isExpandable={filteredDashboardsTopResults?.length !== 0}
        dashboards={filteredDashboardsOtherResults || []}
        highlighFields={['tags', 'areas', 'description']}
        actions={{
          favorite: true,
          info: true,
        }}
      />
      <DashboardsModal highlighFields={['keyTags', 'tags', 'description']} />
    </>
  );
};

export default Search;
